import type { ScreenContext } from '../../shared';
import { h } from '../../ui';

export function cardGuide(ctx: ScreenContext, open = false, modern = true): HTMLElement {
  return h('details', { class: 'folio-guide', attrs: { open } },
    h('summary', null, ctx.t('cards.guide.title')),
    h('div', { class: 'folio-guide-body' },
      (['goal', 'rows', 'effect', 'pass', 'hand'] as const).map(topic =>
        h('section', null, h('h3', null, ctx.t(`cards.guide.${topic}.title`)), h('p', null, ctx.t(modern && topic === 'rows' ? 'cards.table.guideRows' : `cards.guide.${topic}.body`)))),
      modern ? h('section', null, h('h3', null, ctx.t('cards.table.guideOrders')), h('p', null, ctx.t('cards.table.newRules'))) : null,
      h('div', { class: 'folio-guide-example' }, h('b', null, modern ? '5 + 3 + 4 = 12' : '5 + 3 = 8'), h('span', null, ctx.t(modern ? 'cards.table.guideExample' : 'cards.guide.example')))));
}
